:host {
  display: inline-block;
}
